:host {
  display: inline-block;
}
